import { createRoot } from "react-dom/client";
import App from "./app/App";
import "./app/i18n";
import "./app/styles/index.css";

const el = document.getElementById("root");
if (!el) throw new Error("root mount point not found");

createRoot(el).render(<App />);
